import CreateThirdPartyCollectionModal from './CreateThirdPartyCollectionModal.container'
export default CreateThirdPartyCollectionModal
